import { render, staticRenderFns } from "./HistoryBloc.vue?vue&type=template&id=74ecba76&scoped=true"
import script from "./HistoryBloc.vue?vue&type=script&lang=ts"
export * from "./HistoryBloc.vue?vue&type=script&lang=ts"
import style0 from "./HistoryBloc.vue?vue&type=style&index=0&id=74ecba76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ecba76",
  null
  
)

export default component.exports